import _ from '../locale';

export const AI_CHAT_FEEDBACK_REACTION = {
    LIKE: 'like',
    DISLIKE: 'dislike',
} as const;

export type AiChatFeedbackReaction =
    (typeof AI_CHAT_FEEDBACK_REACTION)[keyof typeof AI_CHAT_FEEDBACK_REACTION];

const AI_CHAT_FEEDBACK_LIKE_CATEGORIES = [
    'relevant_query',
    'decision_making',
    'useful',
    'right_topic',
    'easy_understand',
    'other',
] as const;

const AI_CHAT_FEEDBACK_DISLIKE_CATEGORIES = [
    'filters_incorrect',
    'results_dont_match',
    'too_generic',
    'missing_data',
    'other',
] as const;

export type AiChatFeedbackCategory =
    | (typeof AI_CHAT_FEEDBACK_LIKE_CATEGORIES)[number]
    | (typeof AI_CHAT_FEEDBACK_DISLIKE_CATEGORIES)[number];

export const AI_CHAT_FEEDBACK_CATEGORIES = {
    [AI_CHAT_FEEDBACK_REACTION.LIKE]: AI_CHAT_FEEDBACK_LIKE_CATEGORIES,
    [AI_CHAT_FEEDBACK_REACTION.DISLIKE]: AI_CHAT_FEEDBACK_DISLIKE_CATEGORIES,
} as const satisfies Record<AiChatFeedbackReaction, readonly AiChatFeedbackCategory[]>;

export interface AiChatFeedbackInput {
    reaction: AiChatFeedbackReaction;
    categories: AiChatFeedbackCategory[];
    comment: string;
}

export interface AiChatFeedbackDetails {
    reaction?: AiChatFeedbackReaction | null;
    comment?: string | null;
    categories?: AiChatFeedbackCategory[] | null;
    created?: string | null;
    updated?: string | null;
}

export const getAiChatFeedbackCategoryLocaleKey = (category: string) =>
    `ai_chat_feedback_category_${category}`;

export const mapReactionValueToLabel = (value: AiChatFeedbackReaction | ''): string => {
    const keyPostfix: string = value === '' ? 'all' : value;
    return _(`insights_ai_feedback_reaction_${keyPostfix}`);
};
